{
  "tams": {
    "run_operation": {
      "initialise_rots_1": "Initialise ROTS 1",
      "initialise_and_process_rots_1": "Initialise and Process ROTS 1",
      "process_rots_1": "Process ROTS 1",
      "open_school_input_n": "Open School Input",
      "open_teacher_input_n_2": "Open Teacher Input",
      "process_rots_n": "Process ROTS N",
      "reset_run": "Reset Run",
      "retry_rots_1": "Retry ROTS 1",
      "retry_rots_n": "Retry ROTS N"
    }
  }
}
